export default __webpack_public_path__ + "static/slide2-dd7302de57048a3ff31961657f063eed.webp";